(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    function getProductCardGalleries() {
      return document.querySelectorAll(
        '.product-card .card-gallery, .resource-card .card-gallery, .resource-list__item .card-gallery'
      );
    }

    function resetGalleryToFirst(gallery) {
      if (!gallery) return;

      const slideshowComponent = gallery.querySelector('slideshow-component');
      const slideshowContainer = gallery.querySelector('slideshow-container');
      const slides = gallery.querySelectorAll('slideshow-slide');

      if (slideshowComponent) {
        try {
          if (typeof slideshowComponent.goToSlide === 'function') {
            slideshowComponent.goToSlide(0);
          }

          if (typeof slideshowComponent.slideTo === 'function') {
            slideshowComponent.slideTo(0);
          }

          if (typeof slideshowComponent.select === 'function') {
            slideshowComponent.select(0);
          }

          if (typeof slideshowComponent.setActiveSlide === 'function') {
            slideshowComponent.setActiveSlide(0);
          }
        } catch (error) {}

        slideshowComponent.dataset.currentSlide = '0';
        slideshowComponent.setAttribute('current-slide', '0');
        slideshowComponent.setAttribute('data-current-slide', '0');
      }

      if (slideshowContainer) {
        try {
          slideshowContainer.scrollTo({
            left: 0,
            top: 0,
            behavior: 'instant'
          });
        } catch (error) {
          slideshowContainer.scrollLeft = 0;
          slideshowContainer.scrollTop = 0;
        }

        slideshowContainer.scrollLeft = 0;
        slideshowContainer.scrollTop = 0;
      }

      slides.forEach((slide, index) => {
        const isFirst = index === 0;

        slide.classList.toggle('is-active', isFirst);
        slide.classList.toggle('active', isFirst);
        slide.classList.toggle('selected', isFirst);

        if (isFirst) {
          slide.removeAttribute('hidden');
          slide.removeAttribute('inert');
          slide.setAttribute('aria-hidden', 'false');
          slide.setAttribute('aria-current', 'true');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.removeAttribute('aria-current');
        }
      });

      requestAnimationFrame(() => {
        if (slideshowContainer) {
          slideshowContainer.scrollLeft = 0;
          slideshowContainer.scrollTop = 0;
        }
      });
    }

    function resetAllProductCardGalleries() {
      getProductCardGalleries().forEach((gallery) => {
        resetGalleryToFirst(gallery);
      });
    }

    function scheduleGalleryReset() {
      resetAllProductCardGalleries();

      setTimeout(resetAllProductCardGalleries, 50);
      setTimeout(resetAllProductCardGalleries, 250);
      setTimeout(resetAllProductCardGalleries, 700);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleGalleryReset);
    } else {
      scheduleGalleryReset();
    }

    window.addEventListener('pageshow', () => {
      scheduleGalleryReset();
    });

    document.addEventListener('shopify:section:load', () => {
      scheduleGalleryReset();
    });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        scheduleGalleryReset();
      }
    });

    document.addEventListener(
      'mouseout',
      (event) => {
        const card = event.target.closest(
          '.product-card, .resource-card, .resource-list__item'
        );

        if (!card) return;

        if (event.relatedTarget && card.contains(event.relatedTarget)) return;

        const gallery = card.querySelector('.card-gallery');

        if (gallery) {
          resetGalleryToFirst(gallery);
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (() => {
        function initProductCardVariants() {
          document.querySelectorAll('[data-product-card-variants]').forEach((wrapper) => {
            if (wrapper.dataset.variantPillsReady === 'true') return;
            wrapper.dataset.variantPillsReady = 'true';

            const jsonEl = wrapper.querySelector('[data-product-card-variant-json]');
            const input = wrapper.querySelector('[data-variant-id-input]');
            const priceEl = wrapper.querySelector('[data-product-card-price]');
            const comparePriceEl = wrapper.querySelector('[data-product-card-compare-price]');
            const addButton = wrapper.querySelector('[data-add-to-cart-button]');
            const addButtonText = wrapper.querySelector('[data-add-to-cart-button-text]');
            const titleLink = wrapper.querySelector('[data-product-card-title-link]');
            const pills = wrapper.querySelectorAll('[data-product-card-variant-pill]');

            if (!jsonEl || !input || !priceEl) return;

            let data = {};

            try {
              data = JSON.parse(jsonEl.textContent || '{}');
            } catch (error) {
              return;
            }

            const variants = Array.isArray(data.variants) ? data.variants : [];
            const sizeOptionIndex = Number.isInteger(data.sizeOptionIndex) ? data.sizeOptionIndex : 0;

            if (!variants.length) return;

            const cardRoot =
              wrapper.closest('product-card') ||
              wrapper.closest('[data-product-card]') ||
              wrapper.closest('.product-card') ||
              wrapper.closest('.card-product') ||
              wrapper.closest('.card-wrapper') ||
              wrapper.closest('.card') ||
              wrapper.closest('li') ||
              wrapper.parentElement;

            if (cardRoot) {
              cardRoot.classList.add('product-card-variant-card-root');
            }

            const fixedVariantId = cardRoot?.dataset.cardVariantId || '';

            if (fixedVariantId) {
              wrapper.dataset.fixedCardVariant = 'true';
            }

            function stopParentOnly(event) {
              if (!event) return;

              event.stopPropagation();

              if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
              }
            }

            function blockCardRedirect(event) {
              if (!event) return;

              event.preventDefault();
              event.stopPropagation();

              if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
              }
            }

            function normalizeSize(value) {
              const raw = String(value || '')
                .trim()
                .toLowerCase()
                .replace(/\s/g, '')
                .replace(/\./g, '')
                .replace(/,/g, '');

              if (raw.includes('300')) return '300g';
              if (raw.includes('1kg') || raw.includes('1000')) return '1kg';

              return raw;
            }

            function getVariantSizeValue(variant) {
              if (!variant) return '';

              if (Array.isArray(variant.options) && variant.options[sizeOptionIndex] != null) {
                return variant.options[sizeOptionIndex];
              }

              return variant.title || '';
            }

            function variantMatchesSize(variant, sizeValue) {
              return normalizeSize(getVariantSizeValue(variant)) === normalizeSize(sizeValue);
            }

            function findVariantBySize(sizeValue) {
              return (
                variants.find((variant) => variantMatchesSize(variant, sizeValue) && variant.available && variant.image) ||
                variants.find((variant) => variantMatchesSize(variant, sizeValue) && variant.available) ||
                variants.find((variant) => variantMatchesSize(variant, sizeValue) && variant.image) ||
                variants.find((variant) => variantMatchesSize(variant, sizeValue))
              );
            }

            function updateCardImage(imageUrl) {
              if (!imageUrl || !cardRoot) return;

              const image =
                cardRoot.querySelector('[data-product-card-image] img') ||
                cardRoot.querySelector('.product-card__image img') ||
                cardRoot.querySelector('.card__media img') ||
                cardRoot.querySelector('.card-media img') ||
                cardRoot.querySelector('.product-card-gallery img') ||
                cardRoot.querySelector('.product-card-media img') ||
                cardRoot.querySelector('a[href*="/products/"] img') ||
                cardRoot.querySelector('img');

              if (!image) return;

              const picture = image.closest('picture');

              if (picture) {
                picture.querySelectorAll('source').forEach((source) => {
                  source.removeAttribute('srcset');
                  source.removeAttribute('data-srcset');
                });
              }

              image.src = imageUrl;
              image.removeAttribute('srcset');
              image.removeAttribute('data-srcset');
              image.setAttribute('data-src', imageUrl);
              image.setAttribute('data-variant-image-active', 'true');
            }

            function updateProductLinks(variantUrl) {
              if (!variantUrl) return;

              if (titleLink) {
                titleLink.href = variantUrl;
              }

              if (!cardRoot) return;

              cardRoot.querySelectorAll('a[href*="/products/"]').forEach((link) => {
                link.href = variantUrl;
              });
            }

            function updateActivePill(variant) {
              const activeSize = normalizeSize(getVariantSizeValue(variant));

              pills.forEach((pill) => {
                const pillSize = normalizeSize(pill.dataset.sizeValue);
                const isActive = pillSize === activeSize;

                pill.classList.toggle('is-active', isActive);
                pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
              });
            }

            function selectVariant(variantId) {
              const variant = variants.find((item) => String(item.id) === String(variantId));

              if (!variant) return;

              wrapper.dataset.currentVariantId = variant.id;
              input.value = variant.id;

              input.dispatchEvent(new Event('change', { bubbles: true }));

              priceEl.textContent = variant.price || '';

              if (comparePriceEl) {
                if (variant.hasCompareAtPrice && variant.compareAtPrice) {
                  comparePriceEl.textContent = variant.compareAtPrice;
                  comparePriceEl.classList.remove('is-hidden');
                } else {
                  comparePriceEl.textContent = '';
                  comparePriceEl.classList.add('is-hidden');
                }
              }

              if (addButton) {
                addButton.disabled = !variant.available;
              }

              if (addButtonText) {
                addButtonText.textContent = variant.available
                  ? data.addToCartText
                  : data.soldOutText;
              }

              updateActivePill(variant);
              updateProductLinks(variant.url);
              updateCardImage(variant.image);
            }

            let lastTouchHandledAt = 0;

            function handlePillSelect(event, pill) {
              blockCardRedirect(event);

              if (!pill || pill.classList.contains('is-disabled')) return;

              const selectedSize = pill.dataset.sizeValue;
              const variant = findVariantBySize(selectedSize);

              if (!variant) return;

              selectVariant(variant.id);
            }

            const touchOptions = {
              capture: true,
              passive: false
            };

            if (!fixedVariantId) {
              pills.forEach((pill) => {
                pill.addEventListener(
                  'touchstart',
                (event) => {
                  stopParentOnly(event);
                },
                touchOptions
              );

              pill.addEventListener(
                'touchend',
                (event) => {
                  lastTouchHandledAt = Date.now();
                  handlePillSelect(event, pill);
                },
                touchOptions
              );

              pill.addEventListener(
                'pointerup',
                (event) => {
                  if (event.pointerType === 'touch' && Date.now() - lastTouchHandledAt < 700) {
                    stopParentOnly(event);
                    return;
                  }

                  handlePillSelect(event, pill);
                },
                true
              );

              pill.addEventListener(
                'click',
                (event) => {
                  if (Date.now() - lastTouchHandledAt < 700) {
                    blockCardRedirect(event);
                    return;
                  }

                  handlePillSelect(event, pill);
                },
                true
              );

              pill.addEventListener(
                'keydown',
                (event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    handlePillSelect(event, pill);
                  }
                },
                true
                );
              });
            }

            selectVariant(fixedVariantId || wrapper.dataset.currentVariantId || input.value || variants[0].id);

            if (fixedVariantId) {
              pills.forEach((pill) => {
                pill.setAttribute('tabindex', '-1');
                pill.removeAttribute('role');
                pill.removeAttribute('aria-pressed');
              });
            }
          });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initProductCardVariants);
        } else {
          initProductCardVariants();
        }

        document.addEventListener('shopify:section:load', initProductCardVariants);
        window.addEventListener('pageshow', initProductCardVariants);
      })();
  } catch(e) { console.error(e); }
})();

})();
